import { render, staticRenderFns } from "./ModalChatMath.vue?vue&type=template&id=1618441e&scoped=true&lang=pug&"
import script from "./ModalChatMath.vue?vue&type=script&lang=ts&"
export * from "./ModalChatMath.vue?vue&type=script&lang=ts&"
import style0 from "./ModalChatMath.vue?vue&type=style&index=0&id=1618441e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618441e",
  null
  
)

export default component.exports